import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'page-error',
    templateUrl: './page-error.component.html',
    standalone: false
})
export class PageErrorComponent {
}
